import React, { useCallback, useEffect, useState } from "react";
import { Modal } from "antd";
import styles from "./index.module.scss";
import Header from "./components/Header";
import Aside from "./components/Aside";
import Footer from "./components/Footer";
import { ModalProps } from "antd/es/modal";
import Viewer from "./components/Viewer";
import useDeviceType from "Utils/useDeviceType";
import {
    CoursewareListItem,
    downloadCourse,
    studyCourse
} from "API/courseware";
import CoursewareContext from "./store";
import { isTrue } from "Utils/filter";

interface CoursewareModalProps extends ModalProps {
    current: string;
    list: CoursewareListItem[];
    onSelect: (current: string) => void;
    onChange: () => void; // 课件状态变化时(比如已学习)调用这个函数
}

export default function CoursewareModal({
    current,
    list,
    onSelect,
    onCancel,
    onChange,
    ...props
}: CoursewareModalProps) {
    const { isMobile } = useDeviceType();
    const [showAside, setShowAside] = useState(!isMobile);

    // 标记课件为已学习
    const markDone = useCallback(
        async (id: string) => {
            if (!list) return;
            const item = list.find(item => item.id === id);
            if (!item) return;
            if (isTrue(item.studyStatusEntity?.studyStatus)) return; // 已经学习过的不用重复标记

            await studyCourse(item);
            onChange();
        },
        [list, onChange]
    );

    // 下载课件, 同时增加下载次数
    const downloadCourseware = useCallback(
        async (id: string) => {
            if (!list) return;
            const item = list.find(item => item.id === id);
            if (!item) return;
            await downloadCourse(item);
            onChange();
        },
        [list, onChange]
    );

    // 选中课件
    const handleSelect = useCallback(
        (id: string) => {
            onSelect(id);
        },
        [onSelect]
    );

    // 自动标记为已学习
    useEffect(() => {
        if (!current) return;
        markDone(current);
    }, [current, markDone]);

    return (
        <Modal
            title={null}
            footer={null}
            className={styles.root}
            closable={false}
            centered
            destroyOnClose
            {...props}>
            <CoursewareContext.Provider
                value={{
                    current,
                    list,
                    onSelect: handleSelect,
                    downloadCourseware,
                    markDone
                }}>
                <Header onCancel={onCancel} />

                <div className={styles.body}>
                    <Aside
                        visible={showAside}
                        onToggle={() => setShowAside(!showAside)}
                    />

                    <div className={styles.container}>
                        <div className={styles.main}>
                            <Viewer />
                        </div>

                        {!isMobile && <Footer />}
                    </div>
                </div>

                {isMobile && (
                    <Footer onShowAside={() => setShowAside(!showAside)} />
                )}
            </CoursewareContext.Provider>
        </Modal>
    );
}
